'use strict';

export class MyProfileCtrl {
    $scope;
    notify;
    jsDataService;
    pageProgress;
    $mdDialog;

    progress = false;
    submitted = false;
    recaptchaResponse;

    postData = {name: '', lastname: '', email: ''};

    constructor($scope, jsDataService, notify, pageProgress, $mdDialog) {
        'ngInject';
        this.$scope = $scope;
        this.$mdDialog = $mdDialog;
        this.notify = notify;
        this.jsDataService = jsDataService;
        this.pageProgress = pageProgress;

        const g = (typeof window !== 'undefined') ? window : {};

        // seed’inam jsDataService iš globalių kintamųjų, kaip daroma DisertacijosListSiteCtrl
        if (typeof g.userData !== 'undefined') this.jsDataService.data.userData = g.userData;
        if (typeof g.submitUrl !== 'undefined') this.jsDataService.data.submitUrl = g.submitUrl;
        if (typeof g.passChangeUrl !== 'undefined') this.jsDataService.data.passChangeUrl = g.passChangeUrl;
        if (typeof g.passChangeConfirmTexts !== 'undefined') this.jsDataService.data.passChangeConfirmTexts = g.passChangeConfirmTexts;

        const ud = this.jsDataService.get('userData', {}) || {};
        this.postData.name = ud.name || '';
        this.postData.lastname = ud.lastname || '';
        this.postData.email = ud.email || '';
    }

    submitProfile(e) {
        const url = this.jsDataService.get('submitUrl', '');
        if (!url) return;

        const rec = this.jsDataService.get('recaptcha', null);
        if (rec) {
            grecaptcha.ready(() => {
                grecaptcha.execute(rec.siteKey, {action: 'submit'}).then((token) => {
                    this.recaptchaResponse = token;
                    this.submitData(e);
                });
            });
        } else {
            this.submitData(e);
        }
    }

    submitData(e) {
        const url = this.jsDataService.get('submitUrl', '');
        if (!url) return;

        const rec = this.jsDataService.get('recaptcha', null);
        const dat = {...this.postData};
        if (rec) {
            dat[rec.field] = this.recaptchaResponse;
        }

        this.$scope.basicHttpConfigProcess({
            url,
            method: 'POST',
            responseType: 'json',
            data: dat
        }).then(() => {
            this.progress = false;
            this.submitted = false;
        }, () => {
            this.progress = false;
            this.submitted = false;
        });
    }

    sendPassChangeMail(ev) {
        const url = this.jsDataService.get('passChangeUrl', '');
        if (!url) return;

        const confirmTexts = this.jsDataService.get('passChangeConfirmTexts', {
            title: '',
            content: '',
            ok: 'OK',
            cancel: 'Cancel'
        });
        const confirm = this.$mdDialog.confirm()
            .title(confirmTexts.title)
            .htmlContent(confirmTexts.content)
            .ariaLabel(confirmTexts.title)
            .targetEvent(ev)
            .ok(confirmTexts.ok)
            .cancel(confirmTexts.cancel);

        this.$mdDialog.show(confirm).then(() => {
            this.$scope.basicHttpConfigProcess({
                url,
                method: 'GET',
                responseType: 'json'
            });
        }, () => {
        });
    }
}
